import * as login from './login';
import * as cafes from './cafes';
import * as comment from './comment';
import * as password from './password';
import * as userProfile from './userProfile';
import * as favorites from './favorites';
import * as financialTransaction from './financialTransaction';
import * as region from './region';
import * as ad from './ad';
import * as reserves from './reserves';
import * as payment from './payment';
import * as channelMessage from './channelMessage';
import * as ticket from './ticket';
import * as introducedCafe from './introducedCafe';
import * as discountCode from './discountCode';
import * as amenities from './amenities';
import * as packages from './packages';
import * as general from './general';

export default {
  ad,
  amenities,
  cafes,
  channelMessage,
  comment,
  discountCode,
  favorites,
  financialTransaction,
  general,
  introducedCafe,
  login,
  packages,
  password,
  payment,
  region,
  reserves,
  ticket,
  userProfile,
};
